function pathMatch(path = "", url = "") {
    const urlPath = url.replace(/(\?.*)|(#.*)/g, "");
    return !!url && path.startsWith(urlPath);
}

export { pathMatch };
//# sourceMappingURL=pathMatchHelper.esm.js.map
